import { css } from 'styled-components';
export const height = css `
  ${({ height, maxHeight, minHeight }) => `
		${height ? `height:${height};` : ''}
		${maxHeight ? `max-height:${maxHeight};` : ''}
		${minHeight ? `min-height:${minHeight};` : ''}
	`}
`;
